import { BaseTour, TourProps } from '../types';
import { AuditDashboardTour } from './AuditDashboardTour';
import { AuditLandingTour } from './AuditLandingTour';
import { PerformanceAssessmentTour } from './PerformanceAssessmentTour';
import { ReportsAnalyticsTour } from './ReportsAnalyticsTour';
import { ReportsAnalyticsTableTour } from './ReportsAnalyticsTableTour';
import { SideBarNavTour } from './SideBarNavTour';
import { TopWidgetTour } from './TopWidgetTour';
import { ActionDetailsTour } from './ActionDetailsTour';
import { RateCardLandingTour } from './RateCardLandingTour';
import { RateCardProviderSelectionTour } from './RateCardProviderSelectionTour';
import { RateCardTableTour } from './RateCardTableTour';
import { RateCardChargesTour } from './RateCardChargesTour';

export class AppTour extends BaseTour {
  content = 'Application Tour';
  tours = {
    topWidget: (props: Partial<TourProps>) => new TopWidgetTour(props),
    sidebar: (props: Partial<TourProps>) => new SideBarNavTour(props),
    auditLanding: (props: Partial<TourProps>) => new AuditLandingTour(props),
    auditDashboard: (props: Partial<TourProps>) => new AuditDashboardTour(props),
    actionDetails: (props: Partial<TourProps>) => new ActionDetailsTour(props),
    performanceAssessment: (props: Partial<TourProps>) => new PerformanceAssessmentTour(props),
    'reports-analytics-chart': (props: Partial<TourProps>) => new ReportsAnalyticsTour(props),
    'reports-analytics-table': (props: Partial<TourProps>) => new ReportsAnalyticsTableTour(props),
    'rate-card-landing': (props: Partial<TourProps>) => new RateCardLandingTour(props),
    'rate-card-provider-selection': (props: Partial<TourProps>) => new RateCardProviderSelectionTour(props),
    'rate-card-table': (props: Partial<TourProps>) => new RateCardTableTour(props),
    'rate-card-charges': (props: Partial<TourProps>) => new RateCardChargesTour(props),
  } as const;
}
